import React from "react";
import AdminHeader from "./AdminHeader";
import AdminNavbar from "./AdminNavbar";
import AccountSidebar from "../components/Accounts/AccountSidebar";
import { Link } from "react-router-dom";

const AdminAccountProfile = () => {
  return (
    <div>
      <AdminHeader />
      <AdminNavbar />
      <div className="bg-[#f0ece1] fixed_width h-[100vh] flex  accounts_main">
        <div className="left w-[20%]">
          <div className="restore_indisde_heading ml-3 mt-5 rounded-sm  bg-gradient-to-t from-blue-900 to-blue-950">
            <p className="text-white  ml-2 font-bold p-1">My Account</p>
          </div>
          <div className="w-[98%]  ml-2">
            <ul>
              <li className="bg-white border-none py-1  hover:bg-gray-400  font-normal text-[15px]">
                <Link to={"/my-account-master/profile"}>My Profile</Link>
              </li>
              <li className=" bg-white border-none py-1 hover:bg-gray-400  font-normal text-[15px]">
                <Link to={"/Aaccountstatement"}> 

                Account Statement
                </Link>
              </li>
              <li className=" bg-white border-none py-1 hover:bg-gray-400  font-normal text-[15px]">
                Activity Log
              </li>
            </ul>
          </div>
        </div>
        <div className="right w-[50%]">
          <div className="account_main   mt-5 ">
            <div className="balance_overview   ml-5 ">
              <div className="account_profile mt-3">
                <div className="main_account">
                  <h2 className="bg-slate-400 p-1 ml-1 text-white font-bold">
                    About You
                  </h2>
                  <ul>
                    <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                      <p className="text-[12px] ml-2">First Name</p>

                      <span className="flex justify-evenly w-[125px] text-[12px] ">
                        AB
                      </span>
                    </li>
                    <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                      <p className="text-[12px] ml-2">Last Name</p>

                      <span className="flex justify-evenly w-[125px] text-[12px] "></span>
                    </li>
                    <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                      <p className="text-[12px] ml-2">Birthday </p>

                      <span className="flex justify-evenly w-[125px] text-[12px] ">
                        AB
                      </span>
                    </li>
                    <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                      <p className="text-[12px] ml-2">Email Name</p>

                      <span className="flex justify-evenly w-[125px] text-[12px] ">
                        AB
                      </span>
                    </li>
                    <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                      <p className="text-[12px] ml-2">Password</p>

                      <span className="flex justify-evenly w-[125px] text-[12px] ">
                        AB
                      </span>
                    </li>
                    <li className="hover:bg-[#fff] p-1 bg-[#fff] font-normal flex border border-solid border-1 border-color:#f0ece1  ">
                      <p className="text-[12px] ml-2">English</p>

                      <span className="flex justify-evenly w-[125px] text-[12px] ">
                        AB
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminAccountProfile;
